import { Content } from '@volkswagen-onehub/fa-content-service';

import {
  FeatureAppTrackingEvent,
  FeatureAppTrackingManager,
} from '../typings/tagging';
import { getDefaultTrackingEvent } from '../hooks/use-tracking-manager';

export const onVWBasicLinkClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
  externalLink: any,
  featureAppVariant?: string,
) => {
  let customEvent: FeatureAppTrackingEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    //@ts-ignore
    contentId: (contentData && contentData.Name) || `Basic link click`,
  };

  if (externalLink) {
    customEvent.link = {
      ...customEvent.link,
      ...externalLink,
    };
  }

  customEvent.content = contentData;

  if (featureAppVariant) {
    customEvent.environment = { ...customEvent.environment, featureAppVariant };
  }

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(`VWBasic_Link_Click`, customEvent);
};

export const onVWBasicFormLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId:
      //@ts-ignore
      (contentData && contentData?.Name) || 'Basic form load',
  };
  customEvent.content = contentData;

  customEvent.form = { FormStart: true, FormTypeMultiple: ['registration'] };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Form_Load', customEvent);
};

export const onVWBasicFormStepButtonClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId:
      //@ts-ignore
      (contentData && contentData?.Name) || 'Basic form step button click',
  };

  customEvent.content = contentData;
  customEvent.form = { FormTypeMultiple: ['registration'] };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_FormStepButton_Click',
      customEvent,
    );
};

export const onVWBasicFormStepLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
  formStart: boolean = false,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    //@ts-ignore
    contentId: (contentData && contentData?.Name) || `Basic form step load`,
  };

  customEvent.form = { FormTypeMultiple: ['registration'], FormStart: formStart };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_FormStep_Load', customEvent);
};

export const onVWBasicLayerLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentId: string,
  country: string = 'CA',
  featureAppVariant?: string,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId,
  };

  customEvent.environment = {
    ...customEvent.environment,
    country: country as any,
    ...(featureAppVariant && { featureAppVariant }),
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Layer_Load', customEvent);
};

export const onVWBasicFormCtaClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId:
      //@ts-ignore
      (contentData && contentData?.Name) || 'Basic form CTA click',
  };
  customEvent.content = contentData;

  customEvent.form = { FormTypeMultiple: ['registration'] };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_FormCTA_Click', customEvent);
};

export const onVWBasicFormErrorMessageLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  {
    code,
    message,
    referringUrl,
    // @ts-ignore
    source,
  }: {
    code: string;
    message: string;
    referringUrl: string;
    source?: 'Form' | undefined;
  }
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
  };

  customEvent.error = { code, message, referringUrl };

  customEvent.form = { FormTypeMultiple: ['registration'] };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_FormErrorMessage_Load',
      customEvent,
    );
};

export const onVWBasicGenericErrorMessageLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  {
    code,
    message,
    referringUrl,
  }: {
    code: string;
    message: string;
    referringUrl: string;
  },
  featureAppVariant?: string,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: message,
  };

  customEvent.error = { code, message, referringUrl };

  if (featureAppVariant) {
    customEvent.environment = { ...customEvent.environment, featureAppVariant };
  }

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_GenericErrorMessage_Load',
      customEvent,
    );
};

export const onVWBasicFormSubmissionSuccessMessageLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId:
      //@ts-ignore
      (contentData && contentData?.Name) ||
      'Basic form submission success message load',
  };

  customEvent.form = { FormTypeMultiple: ['registration'] };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_FormSubmissionSuccessMessage_Load',
      customEvent,
    );
};

export const onVWBasicButtonClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  contentData: Content,
  featureAppVariant?: string,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    //@ts-ignore
    contentId: (contentData && contentData.Name) || 'Basic button click',
  };
  customEvent.content = contentData;

  if (featureAppVariant) {
    customEvent.environment = { ...customEvent.environment, featureAppVariant };
  }

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Button_Click', customEvent);
};

export const onVWBasicStepLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Step load - ${processData.Name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Step_Load', customEvent);
};

export const onVWBasicNavigationButtonClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
  linkData: {
    name: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Navigation button click - ${linkData.name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  customEvent.link = {
    name: linkData.name,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Button_Click', customEvent);
};

export const onVWBasicVehicleSelectClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Vehicle select click - ${processData.Name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_VehicleSelect_Click',
      customEvent,
    );
};

export const onVWBasicStepNavigationClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Step navigation click - ${processData.Name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_StepNavigation_Click',
      customEvent,
    );
};

export const onVWBasicDealerSearchClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Dealer search click - ${processData.Name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_DealerSearch_Click',
      customEvent,
    );
};

export const onVWBasicDealerSelectClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Dealer select click - ${processData.Name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent(
      'VWBasic_DealerSelect_Click',
      customEvent,
    );
};

/**
 * Track dealer card icon button clicks
 * Sends VWBasic_Button_Click event with process and link information
 */
export const onVWBasicDealerCardButtonClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
  linkData: {
    name: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Dealer card button click - ${linkData.name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  customEvent.link = {
    name: linkData.name,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Button_Click', customEvent);
};

/**
 * Reusable helper for VWBasic_Link_Click events
 * Sends VWBasic_Link_Click event with process and link information
 */
export const onVWBasicLinkClickWithProcessEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
  linkData: {
    name: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Link click - ${linkData.name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  customEvent.link = {
    name: linkData.name,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Link_Click', customEvent);
};

/**
 * Reusable helper for VWBasic_Button_Click events with process and link information
 * Sends VWBasic_Button_Click event with process and link information
 */
export const onVWBasicButtonClickWithProcessEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
  linkData: {
    name: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Button click - ${linkData.name}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  customEvent.link = {
    name: linkData.name,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_Button_Click', customEvent);
};

/**
 * Track content tab clicks
 * Sends VWBasic_ContentTab_Click event with process information
 */
export const onVWBasicContentTabClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Content tab click - ${processData.StepName}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_ContentTab_Click', customEvent);
};

/**
 * Track info message loads
 * Sends VWBasic_InfoMessage_Load event with process information
 */
export const onVWBasicInfoMessageLoadEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Info message load - ${processData.StepName}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_InfoMessage_Load', customEvent);
};

/**
 * Track accordion open clicks
 * Sends VWBasic_AccordionOpen_Click event with process information
 */
export const onVWBasicAccordionOpenClickEvent = (
  trackingManager: FeatureAppTrackingManager,
  processData: {
    Name: string;
    StepName: string;
    StepNumber: string;
  },
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: `Accordion open click - ${processData.StepName}`,
  };

  customEvent.process = {
    /* @ts-ignore */
    Name: processData.Name,
    StepName: processData.StepName,
    StepNumber: processData.StepNumber,
  };

  trackingManager &&
    trackingManager.trackMyVWGlobalEvent('VWBasic_AccordionOpen_Click', customEvent);
};